<template>
  <div data-app>
    <div class="uk-card uk-card-small uk-card-default" style="min-height: calc(100vh - 30px);">
      <!--шапка-->
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <!--заголовок-->
          <div class="uk-width-expand uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
            <div>
              <button @click="showInfoModal">
                <md-icon>info</md-icon>
              </button>
            </div>
            <div>
              <h3 class="uk-card-title uk-margin-remove-top uk-margin-right">
                {{ local_page_keys.progress_report }}
              </h3>
            </div>
          </div>
          <!--переключатель табов-->
          <div class="uk-width-auto">
            <v-tabs v-model="tab">
              <v-tab
                  v-for="tabHeader of getTabHeaders"
                  :key="tabHeader.value"
                  :href="`#${tabHeader.value}`"
              >
                {{ tabHeader.text }}
              </v-tab>
            </v-tabs>
          </div>
        </div>
      </div>
      <!--табы-->
      <div class="uk-padding-small">
        <v-tabs-items v-model="tab">
          <v-tab-item
              v-for="group of getTabHeaders"
              :key="group.value"
              :id="group.value"
              style="min-height: calc(100vh - 140px);">
            <!--таб ОБЩИЕ ПОКАЗАТЕЛИ-->
            <template v-if="group.value === 'common'">
              <AdminCommonRatingTable
                  :commonItems="commonItems"
                  :loading="loadingCommonRaw"
                  @loadCommonMore="getCommonMore"></AdminCommonRatingTable>
            </template>
            <!--таб ПО ПОЛЬЗОВАТЕЛЮ-->
            <template v-else-if="group.value === 'by_user'">
              <div>
                <div class="uk-grid uk-grid-small uk-flex-bottom" data-uk-grid>
                  <!--выбор роли-->
                  <div class="uk-width-medium">
                    <div class="uk-margin-xsmall uk-text-small">
                      {{ local_page_keys.lable_role_select }}
                    </div>
                    <select class="uk-select"
                            v-model="choosenRole"
                            name="choosenRole"
                            id="choosenRoleNew"
                            v-on:change="showUserSelect()">
<!--                      <option value="" disabled selected hidden>&#45;&#45;</option>-->
                      <option v-for="option in roles"
                              :key="option.value"
                              :value="option.value"
                              v-text="option.text">
                      </option>
                    </select>
                  </div>
                  <!--выбор статуса-->
                  <div class="uk-width-medium" v-if="choosenRole">
                    <div class="uk-margin-xsmall uk-text-small">
                      {{local_page_keys.label_user_status}}
                    </div>
                    <select class="uk-select" v-model="selectedStatus">
                      <option v-for="status in listOfStatuses" :value="status.value" :key="status.value">
                        <template>{{ status.name }} </template>
                      </option>
                    </select>
                  </div>
                  <!--выбор пользователя-->
                  <div class="uk-width-expand" v-if="Object.keys(users_for_history).length > 0" :mdClearable="true">
                    <div class="uk-margin-xsmall uk-text-small">
                      {{ local_page_keys.lable_user_select }}
                      <button><md-icon>info</md-icon></button>
                      <div class="uk-dropdown tm-dropdown tm-dropdown-bottom-center"
                           data-uk-dropdown="animation: uk-animation-slide-top-small; pos: bottom; delay-hide: 0; delay-show: 0; offset: 10">
                        Значения по отметкам в данном выпадающем списке обновляются каждые 30 минут. Необходима перезагрузка страницы.
                      </div>
                    </div>
                    <v-select
                        v-model="chosenUser"
                        :options="formattedUserForHistory"
                        label="text"
                        :reduce="user => user.value"
                        @input="changeUserSelect"
                        class="tm-v-select">
                    </v-select>
                  </div>

                  <!--кнопка показать-->
                  <div class="uk-width-auto" v-if="showShowWorkerButton">
                    <button @click="getMore(false, 0)"
                            :disabled="items && items.length > 0"
                            class="uk-button uk-button-success tm-button-schedule-table"
                            style="color: #fff !important;line-height: 22px;">
                      {{ local_page_keys.lable_button_show_order_period }}
                      <span v-if="loadingRaw"
                            class="uk-icon uk-spinner uk-margin-left uk-light"
                            data-uk-spinner="ratio: 0.6"></span>
                    </button>
                  </div>
                  <!--сброс фильтра-->
                  <div class="uk-width-auto" v-if="showShowWorkerButton">
                    <button class="uk-button uk-button-success tm-button-schedule-table"
                            data-uk-tooltip="Сбросить фильтрацию"
                            @click="clearSelectedOptions">
                      <md-icon style="height: 22px;">clear</md-icon>
                    </button>
                  </div>
                </div>
              </div>
              <RatingTable v-if="items && items.length > 0"
                           :items="items"
                           :loading="loadingRaw"
                           :individual-fields="fields"
                           :multiRow = true
                           :selectOrder="selectOrder"
                           :chosenUserEmail="getEmailById(chosenUser)"
                           :choosenRole="choosenRole"
                           :user_id = "user_id"
                           @loadMore="getMore"
              ></RatingTable>
            </template>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

    <!--Просмотр заказа-->
    <md-dialog
        :md-active.sync="showDialog"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-progress-report tm-dialog-admin-order-history">
      <a href="#" class="uk-position-top-right tm-dialog-close" @click="closeOrderView()">
        <span class="material-icons">close</span>
      </a>
      <div>
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-1-2">
            <v-tabs v-model="tabInfo">
              <v-tab class="uk-background-muted">
                {{ local_page_keys.tab_title_history_order}}
              </v-tab>
              <v-tab class="uk-background-muted">
                {{ local_page_keys.tab_title_info_order}}
              </v-tab>
            </v-tabs>
          </div>
          <div class="uk-width-1-2 uk-text-center">
            <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
              <div>
                <a href="#"
                   :disabled="activeOrderKey <= 0"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                   role="button"
                   data-uk-tooltip="title: Предыдущий заказ"
                   @click="prevOrder">
                  <span class="material-icons">chevron_left</span>
                </a>
              </div>
              <div>
                <a href="#"
                   :disabled="activeOrderKey >= (activeOrders.length-1)"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success"
                   role="button"
                   data-uk-tooltip="title: Следующий заказ"
                   @click="nextOrder">
                  <span class="material-icons">chevron_right</span>
                </a>
              </div>
              <div>
                <button type="button"
                        @click="orderSignedUrl2Clipboard"
                        style="padding: 0 5px;"
                        class="uk-icon uk-link-text" data-uk-tooltip="title: Создать ссылку на заказ для просмотра">
                  <md-icon>content_copy</md-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-tabs-items v-model="tabInfo">
        <v-tab-item style="min-height: 600px; max-height: 90vh; overflow-y: auto;">
          <v-card flat>
            <v-card-text>
              <div v-if="loadingOrderView">
                <v-progress-circular
                    :width="2"
                    indeterminate
                    style="color: forestgreen"></v-progress-circular>
              </div>
              <div class="uk-position-relative tm-modal-page">
                <div class="uk-grid uk-flex-middle" data-uk-grid>
                  <div class="uk-width-auto">
                    <h4>{{ this.local_page_keys.order_number }}: {{ order_id }}</h4>
                  </div>
                </div>
                <div class="uk-margin" v-if="!activeOrderReload">
                  <OrderView :orderWeekComment="orderWeekComment" @orderInfo="handleOrderInfo($event)"></OrderView>
                </div>
                <hr class="uk-margin-medium">
                <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
                <prev-orders-block-for-admin :currentOrderId="order_id"></prev-orders-block-for-admin>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item style="min-height: 600px; max-height: 90vh; overflow-y: auto;">
          <v-card flat>
            <v-card-text>
              <div class="uk-padding uk-position-relative tm-modal-page">
                <div class="text-center">
                  <md-dialog-title>
                    {{ local_page_keys.order_history_info_dialog_title }}№ {{ modal_info.order_number }}
                  </md-dialog-title>
                </div>
                <md-dialog-content>
                  <div v-if="loadingOrderHistoryInfo">
                    <v-progress-circular
                        :width="2"
                        indeterminate
                        style="color: forestgreen"></v-progress-circular>
                  </div>
                  <div v-if="Object.keys(modal_info).includes('info_table')" class="uk-margin">
                    <md-table>
                      <md-table-row>
                        <md-table-head v-for="header of headersInfoTable" :key="header.id" :label="header.text">
                          {{ header.text }}
                        </md-table-head>
                      </md-table-row>
                      <md-table-row>
                        <md-table-cell v-for="header of headersInfoTable" :key="header.id">
                          <template v-if="(header.value === 'last_retoucher' || header.value === 'last_pro_retoucher')">
                            {{ modal_info.info_table[header.value] === '' ? modal_info.info_table[header.value] : modal_info.info_table[header.value] ? modal_info.info_table[header.value].name : '-'}}
                          </template>
                          <template v-else>
                            {{ modal_info.info_table[header.value] }}
                          </template>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div v-if="Object.keys(modal_info).includes('particular_table')" class="uk-margin">
                    <div class="text-center" v-if="!showParticularInfoTable">
                      <button class="btn btn-outline-primary" @click="showParticularInfoTable = !showParticularInfoTable">
                        {{ local_page_keys.modal_button_show_particular_table }}
                      </button>
                    </div>
                    <div v-else>
                      <div class="text-center">
                        <button class="btn btn-outline-dark" @click="showParticularInfoTable = !showParticularInfoTable">
                          {{ local_page_keys.modal_button_hide_particular_table }}
                        </button>
                      </div>
                      <md-table>
                        <md-table-row>
                          <md-table-head v-for="header of headersParticularInfoTable" :key="header.id" :label="header.text">
                            {{ header.text }}
                          </md-table-head>
                        </md-table-row>
                        <md-table-row v-for="item of sortByDate(modal_info.particular_table)" :key="item.id">
                          <md-table-cell v-for="header of headersParticularInfoTable" :key="header.id">
                            {{ item[header.value] }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                </md-dialog-content>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </md-dialog>

    <ModalAdminRatingInfo v-if="showInfo" @close="closeInfoModal"/>

  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import RatingTable from "@/pages/Dashboard/Tables/RatingTable";
import AdminCommonRatingTable from "@/pages/Dashboard/Tables/AdminCommonRatingTable";
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";
import localStorageMixin from '@/mixins/saveFilterParamsLocalStorageMixin';
import ModalAdminRatingInfo from "../Components/Dialogs/ModalAdminRatingInfo.vue";

export default {
  name: 'ProRetouchersProgressReport',
  data: () => ({
    local_page_keys: {},
    showDialog: false,
    page: 0,
    adminPage: 1,
    items: [],
    commonItems: [],
    moreItemsButton: true,
    order_id: null,
    loadingRaw: false,
    loadingCommonRaw: false,
    activeOrders: [],
    activeOrderKey: null,
    activeOrderReload: false,
    activeOrderInfo:null,
    roles: [
      {
        text: "pro-retouchers",
        value: "pro-retoucher"
      },
      {
        text: "retouchers",
        value: "retoucher"
      },
      {
        text: "junior-retouchers",
        value: "junior-retoucher"
      }
    ],
    choosenRole: 'pro-retoucher',
    chosenUser: null,
    users_for_history: [],
    loading: false,
    tab: 'by_user',
    fields: [
      {
        key: 'weekly-bonus',
        key_lang: 'pr_weekly_bonus',
        icon: 'percent',
        countIcons: 1,
        title: 'Weekly bonus',
        order: 10,
        role:'all'
      },
      {
        key: 'total',
        icon: 'tag',
        key_lang: 'pr_number_of_orders',
        title: 'Orders',
        countIcons: 1,
        order: 20,
        role:'all'
      },
      {
        key: 'sloppy-work',
        key_lang: 'pr_sloppy_work',
        icon: 'gpp_bad',
        countIcons: 1,
        title: 'Sloppy Work',
        withOrders: true,
        order: 95,
        role:'pro-retoucher'
      },
      {
        key: 'number_of_rejects',
        key_lang: 'pr_number_of_rejects',
        icon: 'report',
        countIcons: 1,
        title: 'Number of rejects',
        order: 100,
        role:'pro-retoucher'
      },
      {
        key: 'number_of_rejected_orders',
        key_lang: 'pr_number_order_rejects_by_retoucher',
        icon: 'report_off',
        countIcons: 1,
        title: 'Number of rejected orders',
        order: 110,
        withOrders: true,
        role:'all'
      },
    ],
    listOfStatuses: [],
    selectedStatus: 'active',
    user_id: null,
    orderWeekComment: null, // для фиксации недели, в которой был оценен заказ
    tabInfo: null,
    loadingOrderView: true,
    loadingOrderHistoryInfo: true,
    modal_info: {},
    headersInfoTable: [],
    headersParticularInfoTable: [],
    showParticularInfoTable: false,
    showInfo: false

  }),
  components: {
    RatingTable, OrderView, AdminCommonRatingTable, PrevOrdersBlockForAdmin, ModalAdminRatingInfo
  },
  mixins: [localStorageMixin],
  methods: {
    async getMore(newRequest = false, page = -1) {
      if (!this.moreItemsButton) {
        return;
      }

      if (!this.chosenUser)
        return;

      if (page >= 0)
        this.page = page;
      this.loadingRaw = true;
      this.moreItemsButton = false;
      let error = "";
      let params = {
        user_id: this.chosenUser,
      }
      await this.$store.dispatch('rating/adminRatingData', {
        page: this.page,
        new: newRequest,
        params
      }).catch((reason => {
        this.moreItemsButton = true;
        error = true;
      }));
      if (!error) {
        let ratingRow = await this.$store.getters['rating/adminRatingData'];
        this.items.push(ratingRow['data']);
        this.user_id = ratingRow['user_id'];

        if (this.choosenRole === 'pro-retoucher') {
          //Для объединения данных по рейтинкгам сеньера на текущей неделе с обычными данными
          let firstWeekData = this.items[0][0].rating;
          let dataAllComments = ratingRow['data_all_comments'];

          if (dataAllComments) {
            const merged = {
              ...firstWeekData,
              ...dataAllComments
            };

            for (const key in merged) {
              if (merged[key] && merged[key].count !== undefined) {
                // Считаем сумму значений count
                merged[key].count = (firstWeekData[key]?.count || 0) + (dataAllComments[key]?.count || 0);
              }
              if (merged[key] && merged[key].items !== undefined) {
                // Объединяем массивы items
                merged[key].items = [...(firstWeekData[key]?.items || []), ...(dataAllComments[key]?.items || [])];
              }
            }

            function removeDuplicates(obj, field) {
              const uniqueValues = {};
              obj[field].items = obj[field].items.filter((item) => {
                if (!uniqueValues[item.order_id]) {
                  uniqueValues[item.order_id] = true;
                  return true;
                }
                return false;
              });
            }

            removeDuplicates(merged, "sloppy-work");
            removeDuplicates(merged, "senior-dislike");

            this.items[0][0].rating = merged;
          }
        }

        this.page++;
        this.moreItemsButton = true;
      }
      this.loadingRaw = false;
    },
    async getCommonMore(newRequest = false) {
      if (this.loadingCommonRaw) {
        return;
      }
      this.loadingCommonRaw = true;
      let error = "";
      await this.$store.dispatch('rating/adminCommonRatingData', {
        page: this.adminPage,
        new: newRequest
      }).catch((reason => {
        this.moreItemsButton = true;
        error = true;
      }));
      if (!error) {
        let ratingRow = await this.$store.getters['rating/adminCommonRatingData'];
        this.commonItems.push(ratingRow);
        this.adminPage++;
        this.moreItemsButton = true;
      }
      this.loadingCommonRaw = false;
    },
    async selectOrder({key, orders, week}) {
      this.activeOrders = orders.map((order) => {
        return order.order_id ?? null;
      });
      this.activeOrderKey = key;
      let order_id = this.activeOrders[key];
      this.orderWeekComment = week
      await this.openOrderView(order_id);
    },
    async openOrderView(order_id) {
      let orderId = Number(order_id)
      this.activeOrderReload = true;
      this.loadingOrderView = true;
      await this.$store.dispatch('order/setViewOrderId', orderId);
      this.order_id = orderId;
      this.showDialog = true;
      this.activeOrderReload = false;
      this.loadingOrderView = false;
      this.showOrderHistory(orderId)
      location.hash = orderId;
    },
    async showOrderHistory(order_id) {
      this.loadingOrderHistoryInfo = true;
      await this.$store.dispatch('adminOrdersHistory/orderHistoryInfo', {order_id});
      let data = await this.$store.getters['adminOrdersHistory/orderHistoryInfo'];
      if (typeof data === 'object') {
        if (Object.keys(data).includes('info_table')) {
          this.modal_info['info_table'] = data.info_table;
        }
        if (Object.keys(data).includes('particular_table') && data.particular_table.length > 0) {
          this.modal_info['particular_table'] = data.particular_table;
        }
        this.modal_info['order_number'] = this.modal_info.info_table['order_number'];
        this.loadingOrderHistoryInfo = false;
      } else {
        this.loadingOrderHistoryInfo = false;
        this.modal_info['error'] =  data;
      }
    },
    handleOrderInfo(e) {
      this.activeOrderInfo = e;
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrderView(this.activeOrders[this.activeOrderKey + 1]);
        this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrderView(this.activeOrders[this.activeOrderKey - 1]);
        this.activeOrderKey--;
      }
    },
    orderSignedUrl2Clipboard() {
      let result = {message: "Что-то пошло не так. Формирование ссылки невозможно", pos: 'top-center', status: 'danger', timeout: 2500};
      let url = '';

      if (this.activeOrderInfo!=null
          && Object.keys(this.activeOrderInfo).includes('order_url_signature')) {
        url = this.activeOrderInfo.order_number + '-' + this.activeOrderInfo.order_url_signature;
        url = window.location.protocol + '//' + window.location.host + '/order/' + url;
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        const successful = document.execCommand('copy');
        document.body.removeChild(input);
        if (successful)
          result = {message: "Ссылка на заказ скопирована в буфер", pos: 'top-center', status: 'success', timeout: 2500}
      }
      UIkit.notification(result);
    },
    async showUserSelect(noClearChosenUser = false) {
      this.users_for_history = [];
      this.items = [];
      if (!noClearChosenUser)
        this.chosenUser = null;
      try {
        let roles = [this.choosenRole];
        await this.$store.dispatch("users/chosenRolesUsersList", {roles, with_rating_stat: true});
        this.users_for_history = await this.$store.getters['users/chosenRolesUsersList'];
      } catch (e) {
        alert(this.local_page_keys.alert_something_went_wrong)
      }
    },
    clearSelectedOptions() {
      this.choosenRole = '';
      this.chosenUser = null;
      this.items = [];
      this.users_for_history = [];
    },
    changeUserSelect() {
      this.items = [];
    },
    getEmailById(userId) {
      var user = Object.values(this.users_for_history).find(function (user) {
        return user.id === userId;
      });
      return user ? user.email : null;
    },
    initListOfStatuses() {
      this.listOfStatuses = [
        {
          value: 'all',
          name: this.local_page_keys.select_users_all
        },
        {
          value: 'active',
          name: this.local_page_keys.select_users_active
        },
        {
          value: 'deleted',
          name: this.local_page_keys.select_users_deleted
        },
      ]
    },
    closeOrderView() {
      this.showDialog = false;
      this.activeOrderInfo = null;
    },
    getHeaders() {
      this.headersInfoTable = [
        {text: this.local_page_keys.modal_info_table_header_order_id, value: 'order_id'},
        {text: this.local_page_keys.modal_info_table_header_order_number, value: 'order_number'},
        {text: this.local_page_keys.modal_info_table_header_last_retoucher, value: 'last_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_last_pro_retoucher, value: 'last_pro_retoucher'},
        {text: this.local_page_keys.modal_info_table_header_created_at, value: 'created_at'},
        {text: this.local_page_keys.modal_info_table_header_updated_at, value: 'updated_at'},
      ];
      this.headersParticularInfoTable = [
        {text: this.local_page_keys.modal_particular_info_table_header_order_date, value: 'date'},
        {text: this.local_page_keys.modal_particular_info_table_header_order_new_status, value: 'new_status'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_role, value: 'user_role'},
        {text: this.local_page_keys.modal_particular_info_table_header_retoucher_email, value: 'user_email'},

      ];
    },
    sortByDate(array) {
      let sortedArray = array.sort(function (a, b) {
        let firstDate = new Date(a.date);
        let secondDate = new Date(b.date);
        return firstDate - secondDate;
      })
      return sortedArray;
    },
    showInfoModal() {
      this.showInfo = true;
    },
    closeInfoModal() {
      this.showInfo = false;
    },
  },
  computed: {
    formattedUserForHistory() {
      const users = Object.values(this.users_for_history);
      let filterUsersByStatus = users;

      if (this.selectedStatus === 'active') {
        filterUsersByStatus = users.filter(function (user) {
          return user.deleted === false;
        });
      } else if (this.selectedStatus === 'deleted') {
        filterUsersByStatus = users.filter(function (user) {
          return user.deleted === true;
        });
      }

      if (this.choosenRole === 'pro-retoucher') {
        return filterUsersByStatus.map(user => ({
          value: user.id,
          text: '🔃 ' + ((user.ratingStat) ? user.ratingStat.proCommentCount : '0') + ' - ' +
              (user.name !== '' ? user.name : user.email) +
              '(' + user.email + ' ' + user.role + ')' +
              ' ✅ ' + ((user.ratingStat) ? user.ratingStat.niceJobCount : '0') +
              ' ❌ ' + ((user.ratingStat) ? user.ratingStat.badJobCount : '0') +
              ' ' + ((user.ratingStat && user.ratingStat.additionalBonuses) ? user.ratingStat.additionalBonuses : '0')
        }))
      } else {
        return filterUsersByStatus.map(user => ({
          value: user.id,
          text: (user.name !== '' ? user.name : user.email) + '(' + user.email + ' ' + user.role + ')'
        }))
      }
    },
    showShowWorkerButton() {
      return this.chosenUser != null;
    },
    getTabHeaders() {
      return [
        {text: 'Общие показатели', value: 'common'},
        {text: 'По пользователю', value: 'by_user'},
      ]
    },
  },
  watch: {
    choosenRole: function (val) {
      this.saveToLocalStorage('choosenRole');
    },
    selectedStatus: function (val) {
      this.saveToLocalStorage('selectedStatus');
    },
    chosenUser: function (val) {
      this.saveToLocalStorage('chosenUser');
    },
  },

  async created() {
    await this.showUserSelect();
    //this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('pro_retoucher_progress_report'), await this.$filtergetLocalisationPage('admin_orders_history'), await this.$filtergetLocalisationPage('users-page'));
    this.local_page_keys = await this.$filtergetLocalisationPages(['pro_retoucher_progress_report','admin_orders_history','users-page']);
    this.initListOfStatuses();

    // this.$root.$on('quality-senior-updated', (data) => {
    //   if (data.pro_retoucher)
    //    this.showUserSelect(true);
    // });

    this.loadFromLocalStorage('selectedStatus', 'choosenRole','chosenUser');
    if (this.chosenUser) {
      this.showUserSelect(true);
      this.moreItemsButton = true;
      await this.getMore(false, 0);
    }
    this.getHeaders();
    await this.getCommonMore();
  },
  beforeDestroy() {
    localStorage.removeItem('ProRetouchersProgressReport_selectedValues');
  },

}
</script>
<style>
/*Layout*/
@import '../../../assets/css/uikit/grid.css';
@import '../../../assets/css/uikit/section.css';
@import '../../../assets/css/uikit/card.css';
@import '../../../assets/css/uikit/table.css';
@import '../../../assets/css/uikit/form.css';
@import '../../../assets/css/uikit/nav.css';
@import '../../../assets/css/uikit/subnav.css';
@import '../../../assets/css/uikit/dropdown.css';
@import '../../../assets/css/uikit/drop.css';
@import '../../../assets/css/uikit/link.css';
@import '../../../assets/css/uikit/modal.css';
@import '../../../assets/css/uikit/accordion.css';

/*Utilities*/
@import '../../../assets/css/uikit/background.css';
@import '../../../assets/css/uikit/label.css';
@import '../../../assets/css/uikit/width.css';
@import '../../../assets/css/uikit/height.css';
@import '../../../assets/css/uikit/flex.css';
@import '../../../assets/css/uikit/margin.css';
@import '../../../assets/css/uikit/padding.css';
@import '../../../assets/css/uikit/position.css';
@import '../../../assets/css/uikit/utility.css';
@import '../../../assets/css/uikit/transition.css';
@import '../../../assets/css/uikit/text.css';
@import '../../../assets/css/uikit/overlay.css';
@import '../../../assets/css/uikit/animation.css';
@import '../../../assets/css/custom.css';

.tm-admin-ratings-table tr .uk-table-expand {
  width: 100%;
}

.tm-admin-ratings-table tr > th {
  padding: 10px 5px;
  position: relative;
}

.tm-admin-ratings-table tr > th:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
}

.tm-admin-ratings-table tr > td {
  padding: 5px;
}

.tm-admin-ratings-table tr > * {
  min-width: 75px;
  max-width: 75px;
}

.tm-admin-ratings-table tr > *:nth-child(1) {
  min-width: 270px;
  max-width: 270px;
}

.tm-admin-ratings-table tr > *:nth-child(2) {
  min-width: 115px;
  max-width: 115px;
}

.tm-admin-ratings-table tr > *:nth-child(3) {
  min-width: 100px;
  max-width: 100px;
}

.tm-admin-ratings-table tr > *:last-child {
  padding-right: 60px;
}

.tm-admin-ratings-table {
  line-height: 1.3;
}


.uk-button-success,
.uk-button-success:hover,
.uk-button-success:focus {
  color: #fff !important;
}

.uk-drop-parent-icon {
  transition: transform .3s ease-out;
}

[aria-expanded=true] > .uk-drop-parent-icon {
  transform: rotateX(180deg)
}

.uk-table-hover > tr:hover, .uk-table-hover tbody tr:hover {
  position: relative;
  z-index: 2;
}

.tm-width-medium {
  width: 240px;
}

.tm-close-stars .material-icons {
  margin-left: -4px;
  margin-right: -4px;
}

.tm-grid-hover > div {
  transition: .1s ease-in-out;
}

.tm-grid-hover > .uk-open,
.tm-grid-hover > div:hover {
  background-color: #f8f8f8;
}

.tm-grid-hover .uk-accordion-title {
  height: 68px;
}

.tm-grid-hover .uk-accordion-title:before {
  display: none;
}

hr,
.uk-hr {
  /* 1 */
  overflow: visible;
  /* 2 */
  text-align: inherit;
  /* 3 */
  margin: 0 0 20px 0;
  border: 0;
  border-top: 1px solid #e5e5e5;
}

/* Add margin if adjacent element */
* + hr,
* + .uk-hr {
  margin-top: 20px;
}
</style>